<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="CablePrices">
      <div slot="toolbar" class="toolbar">
        <el-button type="primary" :loading="exportLoading" @click="exportData()">导出</el-button>
        <el-button type="primary" plain :loading="exportLoading2" @click="selectCuProperty">根据铜价导出模板</el-button>
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            title="选择铜价"
            width="450px"
            top="10vh"
            @close="dialogClose">
          <el-form
              ref="form"
              :model="filter"
              :rules="ruleValidate"
              class="form"
              label-width="80px">
            <el-form-item label="铜价" prop="cuPriceDisplayValue">
              <el-select v-model.trim="filter.cuPriceDisplayValue" clearable placeholder="请选择">
                <el-option
                    v-for="item in cuPropertyList"
                    :key="item.id"
                    :label="item.displayValue"
                    :value="item.displayValue"/>
              </el-select>
            </el-form-item>
            <el-form-item label="产品名称" prop="materialName">
              <el-input v-model.trim="filter.materialName" clearable placeholder="请输入产品名称"/>
            </el-form-item>
          </el-form>
          <span slot="footer">
            <el-button @click="dialogVisible=false">取消</el-button>
            <el-button :loading="submitLoading2" type="primary" @click="exportFile()">确认</el-button>
          </span>
        </el-dialog>
        <el-button icon="el-icon-upload2" type="success" @click="dialogVisible2 = true" style="margin-left: 5px">导入</el-button>
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible2"
            title="提示"
            width="450px"
            top="10vh"
            @close="dialogClose2">
          <div>EXCEL表格只需要维护面价,其余价格导入时自动计算</div>
          <span slot="footer">
            <el-button @click="dialogVisible2=false">取消</el-button>
            <el-upload
                :action="uploadUrl"
                :headers="uploadHeaders"
                :before-upload="beforeAvatarUpload"
                :disabled="disabled"
                :on-error="handlerError"
                :on-exceed="onExceed"
                :on-progress="onProgress"
                :on-success="handleSuccess"
                :show-file-list="false"
                accept=".xlsx"
                style="display: inline-block;margin: 0 5px">
              <el-button type="primary" :loading="importLoading">导入</el-button>
            </el-upload>
          </span>
        </el-dialog>
      </div>
      <div slot="adSearch">
        <vm-search label="物料名称">
          <el-input v-model="filter.materialName" placeholder="请输入物料名称" clearable/>
        </vm-search>
        <vm-search label="特性">
          <el-input v-model="filter.propertyName" placeholder="请输入特性" clearable/>
        </vm-search>
        <vm-search label="特性值">
          <el-input v-model="filter.propertyValue" placeholder="请输入特性值" clearable/>
        </vm-search>
        <vm-search label="特性值描述">
          <el-input v-model="filter.displayValue" placeholder="请输入特性值" clearable/>
        </vm-search>
        <vm-search label="铜价">
          <el-input v-model="filter.cuPriceDisplayValue" placeholder="请输入铜价" clearable/>
        </vm-search>
      </div>
      <el-table-column label="物料名称" prop="materialName" align="left" width="180"/>
      <el-table-column label="特性" prop="propertyName" align="center" width="100"/>
      <el-table-column label="特性值" prop="propertyValue" align="center" width="100"/>
      <el-table-column label="物料号" prop="sapMaterialNo" align="center" width="100"/>
      <el-table-column label="特性值描述" prop="displayValue" align="left" min-width="240"/>
      <el-table-column label="铜价" prop="cuPriceDisplayValue" align="center" width="80"/>
      <el-table-column label="标准价格" prop="standardPrice" align="center" width="80"/>
      <el-table-column label="成本价格" prop="costPrice" align="center" width="80"/>
      <el-table-column label="谊新结算价" prop="yiXinSettlementPrice" align="center" width="95"/>
      <el-table-column label="销售员" prop="level1Price" align="center" width="80"/>
      <el-table-column label="区总" prop="level2Price" align="center" width="80"/>
      <el-table-column label="总监" prop="level3Price" align="center" width="80"/>
      <el-table-column label="操作" align="center" width="80">
        <template v-slot="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <edit-page ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable";
  import VmSearch from "@/components/VmSearch";
  import EditPage from "./CablePricesEdit.vue";
  import loginUtil from "@/util/loginUtil";
  export default {
    components:{ VmTable, VmSearch, EditPage},
    data() {
      return {
        exportLoading:false,
        exportLoading2:false,
        dialogVisible:false,
        dialogVisible2:false,
        submitLoading:false,
        submitLoading2:false,
        importLoading:false,
        disabled: false,
        isShow: false,
        uploadUrl: window.config.basicServerUrl + "CablePrices/importFile",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        cuPropertyList:[],
        filter:{
          materialName:"",
          propertyName:"",
          displayValue:"",
          cuPriceDisplayValue:"",
        },
        ruleValidate: {
          cuPriceDisplayValue:{required: true, message: "铜价不能为空",trigger: "blur"},
          materialName:{required: true, message: "物料名称不能为空",trigger: "blur"},
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods:{
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      //导出
      exportData() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","CablePrices/exportData", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      //
      selectCuProperty() {
        this.dialogVisible = true;
        this.getCablePrices();
      },
      //获取铜价列表
      getCablePrices() {
        this.$http.get("basic","CablePrices/cuProperty")
          .then(res=>{
            console.log(res);
            this.cuPropertyList = res;
          });
      },
      //关闭铜价弹窗
      dialogClose() {
        this.$refs.form.resetFields();
      },
      //根据铜价导出模板
      exportFile() {
        this.submitLoading2 = true;
        this.$http
          .exportFile("basic","CablePrices/exportFile", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.submitLoading2 = false;
            this.dialogVisible = false;
          })
          .catch(() => {
            this.submitLoading2 = false;
            this.dialogVisible = false;
          });
      },

      //导入
      dialogClose2() {
        this.dialogVisible2 = false;
      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.dialogVisible2 = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        this.dialogVisible2 = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },

    },
  };
</script>

<style>

</style>